import { ReactNode, Ref } from 'react'
import {
  Container,
  Subheader,
  HomePageSection,
  Title,
  HeroBox,
  ForceFullWidth,
  Background,
} from './styled'

import { Box } from '../../shared_components/UI/Box'
import styled from 'styled-components'
import { MaxWidth, usePageMaxWidth } from '../Page'

export const VideoContainer = styled.div<{ $height?: string }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: ${({ $height }) => $height ?? '100dvh'};
  overflow: hidden;
  z-index: 1;

  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media (min-height: 1079px) {
    height: ${({ $height }) => $height ?? 'auto'};
  }

  @media (min-width: 1600px) {
    background-size: contain;
    ::before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      overflow: hidden;
      width: 100%;
      // max-width: calc((100vw - 1400px) / 2);
      max-width: calc((100vw - 1400px));
      height: 100%;
      z-index: 1;
      background: linear-gradient(90deg, #04111b 50%, rgba(4, 17, 27, 0) 100%);
    }
    ::after {
      content: '';
      position: absolute;
      right: 0;
      top: 0;
      overflow: hidden;
      width: 100%;
      // max-width: calc((100vw - 1400px) / 2);
      max-width: calc((100vw - 1400px));
      height: 100%;
      z-index: 1;
      background: linear-gradient(-90deg, #04111b 50%, rgba(4, 17, 27, 0) 100%);
    }
  }
`

export const RadialGradient = styled.div`
  position: relative;
  height: 100%;
  ::after {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    content: '';
    background-image: radial-gradient(
      54.86% 54.7% at 61.16% 39.14%,
      #ffffff00 0%,
      #04111b 100%
    );
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }
`

export const Wrapper: React.FC<{
  children: React.ReactNode
  isFullSize: boolean
}> = ({ children, isFullSize }) => {
  if (isFullSize) {
    return <ForceFullWidth>{children}</ForceFullWidth>
  }
  return <>{children}</>
}

export default function Hero({
  backgroundUrl,
  mobileBackgroundUrl,
  backgroundGradient,
  videoUrl,
  logo,
  title,
  subHeader,
  buttons,
  children,
  h = '906px',
  mobileH = '573px',
  mw = '673px',
  pt = '320px',
  pb = '100px',
  mobilePt = '300px',
  mobilePb = '100px',
  position = 'relative',
  heroOverflow = 'hidden',
  heroMobileFlexDirection = 'column',
  heroFlexDirection = 'row',
  bgTop,
  isFullSize,
  bgColor,
  hideDefaultContent,
  bottomRightDecorationImage,
  bottomRightCharacterImage,
  heroRef,
}: {
  backgroundUrl?: string
  mobileBackgroundUrl?: string
  backgroundGradient?: string
  videoUrl?: string
  logo?: ReactNode
  title?: ReactNode
  subHeader?: ReactNode
  buttons?: ReactNode
  children?: ReactNode
  h?: string
  mobileH?: string
  mw?: string
  pt?: string
  pb?: string
  mobilePt?: string
  mobilePb?: string
  position?: string
  bgTop?: number
  heroOverflow?: string
  heroFlexDirection?: string
  heroMobileFlexDirection?: string
  isFullSize?: boolean
  bgColor?: string
  hideDefaultContent?: boolean
  bottomRightDecorationImage?: string
  bottomRightCharacterImage?: string
  heroRef?: Ref<HTMLDivElement>
}) {
  const maxWidth = usePageMaxWidth()
  console.log({ heroRef }, 'hero')
  return (
    <Wrapper isFullSize={isFullSize}>
      {backgroundUrl && !videoUrl && (
        <ForceFullWidth position={position}>
          <Background
            backgroundUrl={backgroundUrl}
            mobileBackgroundUrl={mobileBackgroundUrl}
            backgroundGradient={backgroundGradient}
            height={h}
            mobileH={mobileH}
            top={bgTop}
          />
        </ForceFullWidth>
      )}
      {videoUrl && (
        <VideoContainer>
          <RadialGradient>
            <video autoPlay loop muted playsInline>
              <source src={videoUrl} type="video/mp4" />
              <Background
                backgroundUrl={backgroundUrl}
                height={h}
                mobileH={mobileH}
              />
            </video>
          </RadialGradient>
        </VideoContainer>
      )}
      <Container
        pb={pb}
        pt={pt}
        mobilePt={mobilePt}
        mobilePb={mobilePb}
        bgColor={bgColor}
        isFullSize={isFullSize}
        ref={heroRef}
      >
        <MaxWidth maxWidth={maxWidth}>
          <HomePageSection>
            <Box c>
              <HeroBox
                overflow={heroOverflow}
                heroMobileFlexDirection={heroMobileFlexDirection}
                heroFlexDirection={heroFlexDirection}
                g={21}
              >
                {!hideDefaultContent && (
                  <>
                    <Box dc g={24} z={2}>
                      {logo}
                      <Box dc g={24} mw={mw}>
                        {title && <Title>{title}</Title>}
                        <Subheader>{subHeader}</Subheader>
                      </Box>
                      {buttons}
                    </Box>
                  </>
                )}
                {children}
              </HeroBox>
            </Box>
          </HomePageSection>
        </MaxWidth>
        {!!bottomRightDecorationImage && (
          <img
            className="bottom-right-decoration"
            alt="bottom right decoration"
            src={bottomRightDecorationImage}
          />
        )}
        {!!bottomRightCharacterImage && (
          <img
            className="bottom-right-decoration character"
            alt="bottom right decoration"
            src={bottomRightCharacterImage}
          />
        )}
      </Container>
      {/* this below provides a buffer for when we position the banner above the header */}
      {isFullSize && (
        <Box style={{ height: h, paddingBottom: pb }} className="padding" />
      )}
      {/* GoHorse is life */}
    </Wrapper>
  )
}
